// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z73Xy{margin-block-end:16px}.ACNSA{display:flex;align-items:center;width:100%;padding:12px 16px;border:1px solid var(--text-on-standard-bg, #d4d4e0);border-radius:8px;background-color:transparent;cursor:pointer;text-align:left;font:inherit}.ACNSA[data-error=true]{border-color:var(--red-700, #f3aaaa)}.MzQIN{margin-top:4px}.BJcLu{min-height:0}.jsJoI{background-color:transparent !important}.RlRC0{background-color:transparent !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContent": `z73Xy`,
	"roleSelector": `ACNSA`,
	"errorText": `MzQIN`,
	"actionsMenu": `BJcLu`,
	"actionsMenuRoot": `jsJoI`,
	"roleSelectionMenu": `RlRC0`
};
export default ___CSS_LOADER_EXPORT___;
